import { api } from '../core/api';
import { MonitoredCycleTime } from '../../types/app/monitoredCycleTime.types';

export const monitoredCycleTimeGetList = (parentId: number) =>
  api
    .get<MonitoredCycleTime[]>(`MonitoredCycleTime/GetList?parentId=${parentId}`)
    .then((res) => res.data);

export const getCount = (parentId?: number) =>
  api
    .get<number>(`MonitoredCycleTime/GetCount` + (parentId ? `?parentId=${parentId}` : ''))
    .then((res) => res.data);
